import type { TooltipProps as ReactTooltipProps } from 'react-tooltip'

const DEFAULT_OFFSET = -4

export function makeOffset(
  offset: number = DEFAULT_OFFSET
): ReactTooltipProps['offset'] {
  return ['top', 'left', 'bottom', 'right'].reduce(
    (acc, position) =>
      Object.assign(acc, { [position]: offset || DEFAULT_OFFSET }),
    {}
  )
}
